import React from "react";

const SystemIntegrationIcon= (props) => (
<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 512 512"
  fill="#fff"
  {...props}
>
  <circle cx="256" cy="256" r="56"/>

  <circle cx="256" cy="80" r="36"/>
  <circle cx="432" cy="256" r="36"/>
  <circle cx="256" cy="432" r="36"/>
  <circle cx="80" cy="256" r="36"/>

  <line x1="256" y1="136" x2="256" y2="200" stroke="#fff" stroke-width="28" stroke-linecap="round"/>
  <line x1="312" y1="256" x2="376" y2="256" stroke="#fff" stroke-width="28" stroke-linecap="round"/>
  <line x1="256" y1="312" x2="256" y2="376" stroke="#fff" stroke-width="28" stroke-linecap="round"/>
  <line x1="136" y1="256" x2="200" y2="256" stroke="#fff" stroke-width="28" stroke-linecap="round"/>
</svg>
);

export default SystemIntegrationIcon;
